import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import { useTranslation } from 'react-i18next';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const BACKENDURL = window.reactInit.backendurl+'/entry';

export default function Review(){
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    // const path = location.pathname.substr(1);

    // const { token } = useAuth();
    // if (!token) navigate('/login');
    const auth = useAuthUser();
    const token = useAuthHeader();
    const [ error, setError ] = useState({});
    const [ submitted, setSubmitted ] = useState(auth.submitted);

    const [ numPages, setNumPages ] = useState(null);

    // const [ answers, setAnswers ] = useState([]);

    useEffect(()=>{
        // refresh answers from backend.
        fetch(BACKENDURL+'/refresh',{ method:'POST',
            headers:{'Authorization':token} } )
        .then( resp => resp.json() )
        .then( resp => {
            if (resp.status) {
                console.log('ERROR!',resp.status);
                setError(resp);
                return;
            }
            console.log('refresh',resp.email);
            
            // let _answers = [];
            // for (let i=0;i<10;i++){
            //     if (resp["q"+i]) {
            //         auth["q"+i] = resp["q"+i];
            //         _answers[i] = resp["q"+i];
            //     }
            // }
            auth.submitted = resp.submitted;

            // setAnswers(_answers);
        } )
        .catch( err => setError(err) );
        
    },[]);

    const handleEdit = ()=>{
        navigate('/application');
    }

    const handleSave = ()=>{

        if (submitted) {
            navigate('/success');
            return;
        }

        const params = {
            email: auth.email,
            lang: i18n.resolvedLanguage
        };
        fetch(BACKENDURL+'/submit',{ method:'POST',
                body:new URLSearchParams(params),
                headers:{'Authorization':token} } )
            .then( resp => resp.json() )
            .then( resp => {
                
                if (resp.success || resp.status===410) { // 410 is already submitted. just ignore it.
                    // continue. 
                    console.log('submitted');
                    auth.submitted = true;
                    auth.dotracking = true;
                    navigate('/success')
                } else {
                    console.log('set error',resp.status);
                    setError(resp);
                }
            } )
            .catch( err => setError(err) );

    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
      }

    return (
        <Container fluid as='main' className="rules">
            <Row className="skinny-row">
                <Col className="text-sm-center">
                    <h2>{t('review.title')}</h2>
                    <p>{t('review.body')}</p>
                </Col>
            </Row>
            <Row className="skinny-row">
                <Col className="form-col p-5">
                    {/* <div>
                        {[...Array(10)].map((x, i) =>
                            <React.Fragment key={i}>
                                <h5>{t(`application.questions.${i}.q`)}</h5>
                                <p>{answers[i]}</p>
                            </React.Fragment>
                        )} 
                    </div> */}
                    <Document file={`${BACKENDURL}/preview/?_id=${auth._id}&lang=${i18n.resolvedLanguage}`} onLoadSuccess={onDocumentLoadSuccess} className="mb-5 preview">
                        {Array.from(
                            new Array(numPages),
                            (el, index) => (
                            <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                renderTextLayer={false} renderAnnotationLayer={false}
                            />
                            ),
                        )}
                    </Document>
                    {/* <iframe src={} className="mb-5" /> */}
                    <div className="text-center">
                        <button onClick={handleEdit} className="button m-2" disabled={submitted}>{t('review.edit.cta')}</button>
                        <button onClick={handleSave} className="button white m-2">{t('review.save.cta')}</button>
                    </div>
                    {error.status && <p className="error text-center mt-3">{t('errors.'+error.status)}</p>}
                </Col>
            </Row>
        </Container>
    );
}